import { render, staticRenderFns } from "./SalesTrendChart.vue?vue&type=template&id=2e334312"
import script from "./SalesTrendChart.vue?vue&type=script&lang=js"
export * from "./SalesTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports